<template>
  <div class="formc">
    <div class="formc-con">
      <el-form :model="data" :rules="rules" ref="elFormRef" label-width="200" scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
        <el-row>
          <el-col :span="12">
            <el-form-item label="报告年度" prop="reportYear">
              <el-input v-model.trim="checkRule.reportYear" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="companyName">
              <el-input v-model.trim="checkRule.companyName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码/注册号" prop="creditCode">
              <el-input v-model.trim="checkRule.creditCode" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业通讯地址" prop="addr">
              <el-input v-model.trim="data.addr" maxlength="50" show-word-limit />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮政编码" prop="postalcode">
              <el-input v-model.trim="data.postalcode" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业联系电话" prop="tel">
              <el-input v-model.trim="data.tel" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model.trim="data.email" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="企业主营业务活动" prop="mainbusiact">
              <el-input v-model.trim="data.mainbusiact" type="textarea" :rows="1" autosize maxlength="600" show-word-limit />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="从业人数" required>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item prop="empnum">
                    <el-input v-model.trim="data.empnum" />
                  </el-form-item>
                </el-col>

                <el-col :span="16">
                  <el-form-item prop="empnumdis">
                    <el-radio-group v-model="data.empnumdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="(其中女性从业人数)" required>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item prop="womempnum">
                    <el-input v-model.trim="data.womempnum" />
                  </el-form-item>
                </el-col>

                <el-col :span="16">
                  <el-form-item prop="womempnumdis">
                    <el-radio-group v-model="data.womempnumdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="企业经营状态" prop="busst">
              <el-select v-model="data.busst">
                <el-option v-for="(item, index) of busstOptions" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业控股情况" prop="holdingsmsg">
              <el-select v-model="data.holdingsmsg">
                <el-option v-for="(item, index) of holdingsmsgOptions" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="是否有对外担保" prop="isdwdb">
              <el-radio-group v-model="data.isdwdb" @change="radioChange($event, 'guaranty‌')">
                <el-radio value="1">是</el-radio>
                <el-radio value="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否有网站或网店" prop="ishasweb">
              <el-radio-group v-model="data.ishasweb" @change="radioChange($event, 'site')">
                <el-radio value="1">是</el-radio>
                <el-radio value="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="本年度是否发生股东股权转让" prop="isgdgqzr">
              <el-radio-group v-model="data.isgdgqzr" @change="radioChange($event, 'change')">
                <el-radio value="1">是</el-radio>
                <el-radio value="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否有投资信息或 购买其他公司股权" prop="istzinfo">
              <el-radio-group v-model="data.istzinfo" @change="radioChange($event, 'invest')">
                <el-radio value="1">是</el-radio>
                <el-radio value="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="formc-con-b">
          <h6>以下为不公示信息</h6>

          <ul>
            <li>
              <span>其中高校毕业生人数</span>
              <el-form-item label="经营者" prop="colgranum" label-width="100">
                <el-input v-model.trim="data.colgranum" />
                <em>人；</em>
              </el-form-item>
              <el-form-item label="雇员" prop="colemplnum" label-width="80">
                <el-input v-model.trim="data.colemplnum" />
                <em>人；</em>
              </el-form-item>
            </li>

            <li>
              <span>其中退役士兵人数</span>
              <el-form-item label="经营者" prop="retsolnum" label-width="100">
                <el-input v-model.trim="data.retsolnum" />
                <em>人；</em>
              </el-form-item>
              <el-form-item label="雇员" prop="retemplnum" label-width="80">
                <el-input v-model.trim="data.retemplnum" />
                <em>人；</em>
              </el-form-item>
            </li>

            <li>
              <span>其中残疾人人数</span>
              <el-form-item label="经营者" prop="dispernum" label-width="100">
                <el-input v-model.trim="data.dispernum" />
                <em>人；</em>
              </el-form-item>
              <el-form-item label="雇员" prop="disemplnum" label-width="80">
                <el-input v-model.trim="data.disemplnum" />
                <em>人；</em>
              </el-form-item>
            </li>

            <li>
              <span>其中失业人员再就业人数</span>
              <el-form-item label="经营者" prop="unenum" label-width="100">
                <el-input v-model.trim="data.unenum" />
                <em>人；</em>
              </el-form-item>
              <el-form-item label="雇员" prop="uneemplnum" label-width="80">
                <el-input v-model.trim="data.uneemplnum" />
                <em>人；</em>
              </el-form-item>
            </li>
          </ul>
        </div>
      </el-form>
    </div>

    <div class="formc-btn">
      <el-button type="primary" color="#d1ab62" size="large" @click="save">保存</el-button>
      <el-button type="primary" color="#d1ab62" size="large" @click="emits('emit', 'gotoPage', 'center')">返回</el-button>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import { busstOptions, holdingsmsgOptions } from "./utils.js";

const props = defineProps({
  data: {
    type: Object,
    defaults() {
      return {};
    },
  },
  inspectionData: {
    type: Object,
    defaults() {
      return {};
    },
  },
});

const checkRule = inject("checkRule");

const elFormRef = ref();

const data = ref({});

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const rules = ref({
  addr: [rulesConfig],
  postalcode: [rulesConfig],
  tel: [rulesConfig],
  email: [rulesConfig],
  mainbusiact: [rulesConfig],
  empnum: [rulesConfig],
  empnumdis: [rulesConfig],
  womempnum: [rulesConfig],
  womempnumdis: [rulesConfig],
  busst: [rulesConfig],
  holdingsmsg: [rulesConfig],
  isdwdb: [rulesConfig],
  ishasweb: [rulesConfig],
  isgdgqzr: [rulesConfig],
  istzinfo: [rulesConfig],
  colgranum: [rulesConfig],
  colemplnum: [rulesConfig],
  retsolnum: [rulesConfig],
  retemplnum: [rulesConfig],
  dispernum: [rulesConfig],
  disemplnum: [rulesConfig],
  unenum: [rulesConfig],
  uneemplnum: [rulesConfig],
});

const radioChange = (e, key) => {
  emits("emit", "isShow", {
    key,
    value: e,
  });
};

const save = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      emits("emit", "submit", data.value);
    }
  });
};

const emits = defineEmits(["emit"]);

onMounted(() => {
  data.value = cloneDeep(props.data);
});
</script>

<style lang="scss" scoped>
.formc {
  :deep(.el-form-item__label) {
    text-align: right;
  }

  .formc-con-b {
    padding: 20px 0;
    margin-top: 20px;
    background-color: #f4f4f4;

    > h6 {
      font-size: 18px;
      color: #804000;
      margin-bottom: 20px;
      margin-left: 20px;
      display: flex;
      align-items: center;

      &::before {
        content: "";
        width: 6px;
        height: 16px;
        background: #804000;
        margin-right: 14px;
      }
    }

    > ul {
      > li {
        display: flex;
        align-items: center;

        > span {
          width: 200px;
          text-align: right;
          flex: 0 0 auto;
          margin-bottom: 18px;
        }

        .el-form-item {
          .el-input {
            width: 200px;
          }

          em {
            margin-left: 2px;
          }
        }
      }
    }
  }
}
</style>
